import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { ITableColumn } from './tabela.model';

@Component({
  selector: 'app-tabela',
  templateUrl: './tabela.component.html',
  styleUrls: ['./tabela.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TabelaComponent),
      multi: true
    }
  ]
})
export class TabelaComponent implements OnInit {
  @Input() data: any[] = [];
  @Input() columns: ITableColumn[] = [];
  @Output() ngModelChange: EventEmitter<any> = new EventEmitter();
  selectedItem: any;
  selectedRowIndex: number | null = null;

  onSelectChange(value: any, item: any) {
    const body = {
      value: value,
      item: item
    };
    this.ngModelChange.emit(body);
  }

  toggleAtivo(item: any) {
    item.ativo = !item.ativo;
    this.selectedItem = item;
  }

  selectRow(index: number) {
    if (this.selectedRowIndex === index) {
      this.selectedRowIndex = null;
    } else {
      this.selectedRowIndex = index;
    }
  }

  constructor() {}

  ngOnInit() {}
}
